import React, { Component } from 'react';
import Helmet from "react-helmet";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from './components/loadingSpinner/';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter
} from 'react-router-dom';

import Header from './components/header/';
import Home from './routes/home';
import NotFound from './routes/notfound';
import Result from './routes/results';
import Line from './routes/line';
import Live from './routes/live';
import Stats from './routes/stats';
import Toto from './routes/toto';
import TotoBet from './routes/toto/bet';
import TotoResult from './routes/toto/result';
import TotoCards from './routes/toto/cards';
import TotoPrevious from './routes/toto/previous';
import TotoCardsall from './routes/toto/cardsall';
import Account from './routes/account';
import AccountBets from './routes/account/bets';
import AccountHistory from './routes/account/history';
import Payout from './routes/payout';
import LoginCard from './routes/login/card';
import Login from './routes/login';
import Logout from './routes/login/logout';
import Rules from './routes/rules';
import ErrorPage from './components/ErrorPage';
// import LineL from './routes/lineL';


const NoTerminalAccess = () => {
  const reloadCounter = localStorage.getItem('reload')

  if (!reloadCounter) {
    localStorage.setItem('reload', 1)
    window.location.reload()
  }

  if (reloadCounter) {
    localStorage.setItem('reload', reloadCounter < 10 ? Number(reloadCounter) + 1 : 1)

    setTimeout(() => {
      window.location.reload()
    }, reloadCounter * 1000)
  }

  return (
    <div className="no-terminal-access">
      <span>Вызовите администратора</span>
    </div>
  )
}

const LoadApp = ({ error }) => (
  error.status ?
    <div className="load-app__error">
      {error.text}
    </div>
    :
    <div className="load-app">
      <LoadingSpinner />
    </div>
)


@inject('appStore')
@observer
class Terminal extends Component {

  // componentWillMount() {
  //   this.props.lineStore.reset();
  // }

  handleClick = () => {
    this.props.appStore.checkTerminal()
  }

  render() {
    if (!this.props.appStore.terminalAccess) {
      return (
        <div className='terminal-status' onClick={this.handleClick}>авторизация терминала</div>
      )
    } else {
      return '';
    }
  }
}

@withRouter
@inject('appStore')
@observer
export default class App extends Component {

  state = {
    error: false
  }

  componentDidMount() {
    localStorage.setItem('lastAction', 0); //refresh last action
    this.props.appStore.initApp();
  }

  componentDidCatch(error, info) {
    console.log(error, info);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) return (<ErrorPage />);
    const { terminalAccess, appLoading, error, cashboxMode } = this.props.appStore;

    return (
      appLoading ?
        <Router>
          <div className="page-layout" >
            {process.env.NODE_ENV === 'development' ? <Terminal /> : ''}
            <Helmet>
              <title>ИРМ</title>
              <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>
            <Header />
            <div className="main">
              {terminalAccess || process.env.NODE_ENV === 'development' ?
                <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/line/:sport?/:league?/:games?/:ross?" component={Line} />
                  <Route path="/live/:sport?/:league?/:games?/:ross?" component={Live} />
                  <Route exact path="/login/card" component={LoginCard} />
                  <Route exact path="/results" component={Result} />
                  <Route exact path="/stats" component={Stats} />
                  {cashboxMode ? <Route exact path="/rules" component={Rules} /> : null}
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/toto" component={Toto} />
                  <Route path="/toto/bet/:betId?" component={TotoBet} />
                  <Route path="/toto/result/:resultId?" component={TotoResult} />
                  <Route path="/toto/cards/:cardId?/:vc?" component={TotoCards} />
                  <Route path="/toto/cardsall/:cardId?/:page?" component={TotoCardsall} />
                  <Route path="/toto/previous" component={TotoPrevious} />
                  <PrivateRoute exact path="/logout/delayed" component={Logout} />
                  <PrivateRoute exact path="/toto" component={Toto} />
                  <PrivateRoute exact path="/account" component={Account} />
                  <PrivateRoute exact path="/account/bets" component={AccountBets} type="bets" />
                  <PrivateRoute exact path="/account/history" component={AccountHistory} type="history" />
                  <PrivateRoute exact path="/payout" component={Payout} type="payout" />
                  <Route component={NotFound} />
                </Switch>
                : <NoTerminalAccess />}
            </div>
          </div>
        </Router>
        : <LoadApp error={error} />
    )
  }
}

const PrivateRoute = inject('accountStore')(observer(({ component: Component, accountStore, type, ...rest }) => (
  <Route {...rest} render={props => (
    accountStore.access && !accountStore.getHideRoutes.includes(type) ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: '/live',
        state: { from: props.location }
      }} />
    )
  )} />
)))


// WEBPACK FOOTER //
// ./src/App.js